'use strict'
// import { musicEqualizer } from '../js/musicBar.js';
import validate from '../js/modules/validate.js';
import send from '../js/modules/send.js';
import ScrollToDonate from './modules/scrollToDonate.js'
import Slideshow from './modules/slideshow.js';
import { Observer } from 'gsap/dist/Observer';
import linearAnimations from './modules/linearAnimations.js';

window.addEventListener("DOMContentLoaded", () => {
	gsap.registerPlugin(ScrollToPlugin);
	gsap.registerPlugin(ScrollTrigger);

	const formWrapper = document.querySelector('#form-wrap');
	const openPopupButton = document.querySelector('.header__button-contact');
	const openButtonsPopup = document.querySelectorAll('.btn-contact');
	const closePopupButton = document.querySelector('.popup__btn-close');

	let form = document.querySelector('#contact-us');


	openButtonsPopup.forEach((button) => {
		button.addEventListener('click', () => {
			formWrapper.classList.add('form-wrap--visible');
			openPopupButton.classList.add('btn-contact--invisible')
			// document.body.style.overflow = 'hidden';
		})
	})


	function closePopup() {
		formWrapper.classList.remove('form-wrap--visible');
		openPopupButton.classList.remove('btn-contact--invisible')
		document.querySelectorAll('.error').forEach((element) => {
			element.classList.remove('error');
		});
		form.reset();
		// document.body.style.overflow = '';
	}
	closePopupButton.addEventListener('click', closePopup);

	linearAnimations();


	const circles = document.querySelectorAll('.circle-svg');

	circles.forEach((circles) => {
		circles.style.animationDuration = `${Math.random() * .5 + .5}s`;
		circles.style.animationDelay = `${Math.random() * .5 + .3}s`;
	});

	let isMusicActive = true;
	const soundWrap = document.querySelector('.header__sound-wrap');
	const soundOn = document.querySelector('.header__title-on');
	const soundOff = document.querySelector('.header__title-off');
	const musicBarsOn = document.querySelector('.header__music-bar-on');
	const musicBarsOff = document.querySelector('.header__bar-off');


	function toggleAnimation() {
		isMusicActive = !isMusicActive;
		musicBarsOn.classList.toggle('header__music-bar-on--off');
		musicBarsOff.classList.toggle('header__bar-off--active');
	}

	soundWrap.addEventListener('click', () => {
		toggleAnimation();
		if (isMusicActive) {
			soundOff.classList.remove('header__title-off--visible');
			soundOn.classList.remove('header__title-on--invisible');
		} else {
			soundOn.classList.add('header__title-on--invisible');
			soundOff.classList.add('header__title-off--visible');
		}

	})


	const animationContainer = document.getElementById('history animation');
	const triggerHistoryAnimation = document.getElementById('history');
	const animation = bodymovin.loadAnimation({
		container: animationContainer,
		path: '../../assets/history/center.json',
		loop: false,
		autoplay: false,
		render: 'svg',
		name: 'history animation',
	});


	const inputOther = document.getElementById('other');

	inputOther.addEventListener('input', (e) => {
		const value = e.target.value;
		const regex = /^(0|[1-9]\d{0,30})$/;
		if (!regex.test(value)) {
			e.target.value = value.replace(/[^0-9]/g, '').replace(/^0+/g, '').substr(0, 30); // remove non-digit characters and leading zeros
		}
	});

	const sumSelectInputs = document.querySelectorAll('.donate__sum-label');
	const otherSum = document.getElementById('other');

	otherSum.addEventListener('click', function () {
		sumSelectInputs.forEach(element => {
			element.classList.add('focused');
		});
		otherSum.placeholder = 'enter any amount';
	});

	otherSum.addEventListener('blur', function () {
		sumSelectInputs.forEach(element => {
			element.classList.remove('focused');
		});
		otherSum.placeholder = 'other';
	});



	let mm = gsap.matchMedia();
	mm.add(
		{
			isMobile: "(max-width: 1280px)",
			isDesktop: "(min-width: 1281px)",
		},
		(context) => {
			let { isMobile, isDesktop } = context.conditions;
			if (isDesktop) {
				gsap.registerPlugin(Observer);
				const SlideMove = () => {
					const slides = document.querySelector('.slides');
					const slideshow = new Slideshow(slides);
					Observer.create({
						type: 'wheel, touch',
						onDown: () => slideshow.prev(),
						onUp: () => slideshow.next(),
						// invert the mouse wheel delta
						wheelSpeed: -1,
						tolerance: 10
					});
				}
				SlideMove();


				let scrollEventListener = () => {
					let timerId = setInterval(playAnimation, 500);

					function playAnimation() {
						if (triggerHistoryAnimation.classList.contains('slide--current')) {

							window.removeEventListener('wheel', scrollEventListener);

							gsap.delayedCall(.3, () => {
								animation.play();
								clearInterval(timerId);
							});
						} else {
							clearInterval(timerId);
						}
					}
				};
				window.addEventListener('wheel', scrollEventListener);

			}
		});



	const donateBtn = document.getElementById('donate-anchor');
	donateBtn.addEventListener('click', () => ScrollToDonate('#mission', '.mission__container', '#donate', '.donate__container', 1));



	validate('input[name="name"]', 'input[name="email"]', '#message', '.btn-submit');
	validate('input[name="name2"]', 'input[name="email2"]', '#message2', '.form__submit-item');

	send('contact-us', 'popup', 'input[name="name"]', 'input[name="email"]', '#message', '.btn-submit', 'popup', "/mailer/mail.php");
	send('contact-us-bottom', 'form', 'input[name = "name2"]', 'input[name = "email2"]', '#message2', '.form__submit-item', 'form', "/mailer/mail.php");
})